import { Bijection } from "@redotech/util/bijection";
import { ObjectId } from "bson";

/**
 * Redo ObjectId code, with type descriptor
 */
export interface RedoCode {
  /** ID */
  id: ObjectId;
  /** Type */
  type: string;
}

/**
 * Compact Redo code format
 */
export const redoCodeFormat: Bijection<string, RedoCode> = {
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  read(string) {
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if (string[0] !== string[0].toUpperCase()) {
      // why does barcode scanner flip case?
      string = string.replace(/./g, function (val) {
        return val !== val.toUpperCase()
          ? val.toUpperCase()
          : val.toLowerCase();
      });
    }
    const parts = string.split(/[_=]/);
    const [type, idString] = parts;
    if (parts.length !== 2) {
      throw new Error("Invalid Redo code format");
    }
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    return { type, id: ObjectId.createFromBase64(idString) };
  },
  write(code) {
    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    if (code.type[0] !== code.type[0].toUpperCase()) {
      throw new Error("Type must be uppercase");
    }
    const idString = code.id.toString("base64");
    return `${code.type}_${idString}`;
  },
};
